import { render, staticRenderFns } from "./oomSlider.vue?vue&type=template&id=b72882d0&scoped=true"
import script from "./oomSlider.vue?vue&type=script&lang=js"
export * from "./oomSlider.vue?vue&type=script&lang=js"
import style0 from "./oomSlider.vue?vue&type=style&index=0&id=b72882d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72882d0",
  null
  
)

export default component.exports